import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionService } from '../../shared/session-service/session.service';
import { Activity } from '../../shared/models/ep-activity.model';
import { ToastrService } from '@kpmg-tax/ui';
import { API_URL } from '../../shared/constants/apiurl-constants';
import { BaseResponse } from 'src/app/shared/models/base-response.model';
import { Messages } from 'src/app/shared/constants/messages';

@Injectable({
  providedIn: 'root',
})
export class DefineActivitiesService {
  activitiesTableRefresh = new BehaviorSubject({});
  refreshActivities = this.activitiesTableRefresh.asObservable();
  activitiesInserted = new BehaviorSubject({});
  activitiesInsrtedAlert = this.activitiesInserted.asObservable();
  selected: any = [];
  masterCheckboxControl: boolean = false;
  private _tableDataFiltered: Array<Activity>;

  constructor(public sessionService: SessionService, public toastrService: ToastrService,) { }

  refreshTable() {
    this.activitiesTableRefresh.next(true);
  }

  get tableDataFiltered(): Array<Activity> {
    return this._tableDataFiltered;
  }
  set tableDataFiltered(value: Array<Activity>) {
    this._tableDataFiltered = value;
  }

  DeleteMultipleActivity = (selectedData: Activity[]) => {
    this.sessionService
      .apiUrlPost(API_URL.ACTIVITY.DELETEBULKACTIVITY, selectedData)
      .subscribe(
        (data: BaseResponse) => {
          if (data !== null && data.success) {
          } else if (
            data !== null &&
            !data.success &&
            data.errorMessage === 'KNOWNERROR'
          ) {
            this.toastrService.setErrorMessage(data.result);
          }
          this.refreshTable();
        });
  }
  GetEngagementActivities(engagementId: number): Observable<any> {
    let activities = this.sessionService.apiUrlGet(
      API_URL.GETENGAGEMENTACTIVITIES + '?engagementId=' + engagementId,
    );
    return activities;
  }
  deleteRowActivity = (row: Activity) => {
    let activityId = row.activityID;

    activityId = Number(activityId);
    let deleteRequest = {
      engagementActivityId: Number(row.activityID),
      engagementId: Number(this.sessionService.getSession('engagementId')),
    };
    this.sessionService
      .apiUrlPost(API_URL.DELETEENGAGEMENTACTIVITY, deleteRequest)
      .subscribe(
        (data: BaseResponse) => {
          if (data !== null && data.success) {
            this.refreshTable();
            // If request is successful, Refresh data table on page
            console.log('#1');
            this.toastrService.setSuccessMessage(
              Messages.Activity.DeleteActivitySuccess + ': ' + row.name,
            );
          } else if (
            data !== null &&
            !data.success &&
            data.errorMessage === 'ASSIGNED'
          ) {
            console.log('#2');
            this.toastrService.setErrorMessage(
              Messages.Activity.ActivityAssignedToSurvey,
            );
          }
        });
  }

  addActivity = (row: Activity) => {
    let eid = this.sessionService.getSession('engagementId');

    let activity: any = {
      name: row.name,
      desc: row.desc,
      qPercentage:
        row.qPercentage !== null
          ? row.qPercentage.toString().replace('%', '')
          : 0,
      engagementId: eid,
      activityType: row.activityType,
    };

    this.sessionService.apiUrlPost(API_URL.ADDENGAGEMENTACTIVITY, activity).subscribe((data: BaseResponse) => {
      if (data.success) {
        this.tableDataFiltered.filter(x => {
          if (x.name === row.name) {
            x.activityID = data.result.activityID;
            x.engagementId = Number(eid);
            this.activitiesInserted.next(x);
          }
        });
      }
    });
  }

  deleteCheckActivity = (row: Activity) => {
    let activityId = row.activityID;

    activityId = Number(activityId);
    let deleteRequest = {
      engagementActivityId: Number(row.activityID),
      engagementId: Number(this.sessionService.getSession('engagementId')),
    };
    this.sessionService.apiUrlPost(API_URL.DELETEENGAGEMENTACTIVITY, deleteRequest).subscribe((data: BaseResponse) => {
      if (data !== null && data.success) {
        // If request is successful, Refresh data table on page
        row.activityID = 0;
        row.engagementId = 0;
        this.activitiesInserted.next(null);
      } else if (
        data !== null &&
        !data.success &&
        data.errorMessage === 'ASSIGNED'
      ) {
        this.toastrService.setErrorMessage(
          Messages.Activity.ActivityAssignedToSurvey,
        );
      }
    });
  }

  saveEngagementActivity(addActivitiesRequest: { engagementId: number, activitiesRequest: { activityId: number, isMasterActivity: boolean }[] }) {
    return this.sessionService.apiUrlPost(API_URL.SAVEENGAGEMENTACTIVITY, addActivitiesRequest);
  }
  deleteEngagementActivity(deleteActivitiesRequest: { engagementId: number, activitiesRequest: { activityId: number, isMasterActivity: boolean }[] }) {
    return this.sessionService.apiUrlPost(API_URL.ACTIVITY.DELETEBULKACTIVITY, deleteActivitiesRequest);
  }
  saveSelectedActivity(activity) {
    return this.sessionService.apiUrlPost(API_URL.ADDENGAGEMENTACTIVITY, activity);
  }
  deleteSelectedActivity(activity) {
    return this.sessionService.apiUrlPost(API_URL.DELETEENGAGEMENTACTIVITY, activity);
  }
}
